import "./App.css";
import Game from "./components/game/Game";

const App = () => {
  return (
    <div>
      <Game />
    </div>
  );
};

export default App;
